export function isBackspace(key: number) {
    return key === 8 || key === 46
}
